export default (theme) => ({
    lightgreyBackground: {
        backgroundColor: "lightgrey",
    },
    lightLeftBorder: {
        borderLeft: "2px solid #bababa",
    },
});
